import React from 'react'
import { Sparkles, X } from 'lucide-react'
import { forceTour } from '../hooks/usePageTour'
import {
  NEWS_FIRMA_GUIADA,
  prepararNovedadFirmaGuiada,
  novedadFirmaGuiadaPendiente,
  novedadFirmaGuiadaPausada,
  pausarNovedadFirmaGuiada,
  dismissNewsTourWithoutViewing,
} from '../config/newsTours'

/**
 * Aviso de la actualización firma-guiada-notas-v2-2026-10.
 * No abre el tour general del dashboard ni modifica la novedad anterior.
 */
export default function DashboardNewsBanner({ userId, onUpdate }) {
  if (userId == null || userId === '') return null
  if (novedadFirmaGuiadaPausada(userId)) return null
  if (!novedadFirmaGuiadaPendiente(userId)) return null

  const handleVerNovedades = () => {
    prepararNovedadFirmaGuiada(userId)
    forceTour(NEWS_FIRMA_GUIADA.id)
  }

  const handleMasTarde = () => {
    pausarNovedadFirmaGuiada(userId)
    onUpdate?.()
  }

  const handleCerrar = () => {
    const tour = prepararNovedadFirmaGuiada(userId)
    if (tour) dismissNewsTourWithoutViewing(tour)
    onUpdate?.()
  }

  return (
    <div
      id="tour-news-firma-guiada-aviso"
      className="mb-6 rounded-xl border border-primary-200 bg-primary-50 px-4 py-4 shadow-sm"
      role="region"
      aria-label="PDFSigner tiene nuevas mejoras"
    >
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between">
        <div className="flex items-start gap-3 min-w-0">
          <Sparkles className="h-5 w-5 text-primary-600 flex-shrink-0 mt-0.5" aria-hidden />
          <div>
            <p className="text-base font-semibold text-gray-900">PDFSigner tiene nuevas mejoras</p>
            <p className="mt-1 text-sm text-gray-700">
              Ahora puedes definir campos de firma, agregar notas trazables y visualizar documentos antes de firmar.
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center gap-2 sm:flex-shrink-0">
          <button
            type="button"
            onClick={handleVerNovedades}
            className="px-3 py-1.5 text-sm font-medium rounded-lg bg-primary-600 text-white hover:bg-primary-700"
          >
            Ver novedades
          </button>
          <button
            type="button"
            onClick={handleMasTarde}
            className="px-3 py-1.5 text-sm font-medium rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Más tarde
          </button>
          <button
            type="button"
            onClick={handleCerrar}
            className="px-3 py-1.5 text-sm font-medium rounded-lg bg-white border border-gray-300 text-gray-700 hover:bg-gray-50"
          >
            Cerrar
          </button>
        </div>
      </div>
    </div>
  )
}
